import styled from "styled-components";
import { breakpoints } from "../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1270px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--white);

  // Logo Seguro Bici
  h1 {
    transition: 0.2s all;
  }

  // Logo Seguro Bici Button
  h1 a {
    cursor: pointer;
  }

  // Logo Seguro Bici Button Image
  h1 a img {
    display: block;
    width: 90%;
  }

  // Logo Seguro Bici Hover
  h1:hover {
    transform: scale(0.92);
  }

  // Numeros de telefono Container
  .numerosSocialMedia {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
  }

  // Numeros de telefono
  .numerosSocialMedia p {
    margin-left: 36px;
    color: var(--black);
    font-family: "Raleway", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }

  // Social Media Container
  .socialMediaContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    margin: 0px 0px 0px 20px;
  }

  .socialMediaContainer a {
    margin: 5px 0px 0px 15px;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    color: var(--orange);
    transition: 0.2s all;
  }

  .socialMediaContainer a:hover {
    color: var(--black);
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    max-width: 1100px;
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    max-width: 1000px;
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    max-width: 850px;
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    max-width: 700px;

    // Numeros de telefono Container
    .numerosSocialMedia {
      width: 60%;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    justify-content: center;
    // Numeros de telefono Container
    .numerosSocialMedia {
      display: none;
    }
  }
`;

export default Container;
